import { AlertTriangle, Info, Loader2 } from 'lucide-react'

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  details,        // array de { label, value, danger? }
  blocked,        // true → não permite excluir, só mostra "Entendido"
  loading,        // true → mostra spinner enquanto carrega detalhes
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'danger'
}) {
  if (!isOpen) return null

  const confirmColors = {
    danger: 'bg-red-600 hover:bg-red-700',
    warning: 'bg-yellow-600 hover:bg-yellow-700',
    info: 'bg-blue-600 hover:bg-blue-700',
    success: 'bg-green-600 hover:bg-green-700'
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>

        <div className="relative bg-white rounded-lg max-w-md w-full p-6 shadow-xl">
          <div className="flex items-center space-x-3 mb-3">
            <div className="flex-shrink-0">
              {blocked
                ? <Info className="w-6 h-6 text-blue-500" />
                : <AlertTriangle className="w-6 h-6 text-red-600" />
              }
            </div>
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
          </div>

          <p className="text-gray-600 mb-4">{message}</p>

          {loading && (
            <div className="flex items-center justify-center py-4 text-gray-400">
              <Loader2 className="w-5 h-5 animate-spin mr-2" />
              <span className="text-sm">Verificando dados...</span>
            </div>
          )}

          {!loading && details && details.length > 0 && (
            <div className="bg-gray-50 rounded-lg border border-gray-200 divide-y divide-gray-200 mb-4">
              {details.map((item, i) => (
                <div key={i} className="flex items-center justify-between px-4 py-2">
                  <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">{item.label}</span>
                  <span className={`text-sm font-semibold ${item.danger ? 'text-red-600' : 'text-gray-800'}`}>
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          )}

          <div className="flex justify-end space-x-3">
            {blocked ? (
              <button
                onClick={onClose}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
              >
                Entendido
              </button>
            ) : (
              <>
                <button onClick={onClose} className="btn-secondary" disabled={loading}>
                  {cancelText}
                </button>
                <button
                  onClick={() => { onConfirm(); onClose() }}
                  disabled={loading}
                  className={`px-4 py-2 text-white rounded-lg font-medium transition-colors disabled:opacity-50 ${confirmColors[type]}`}
                >
                  {confirmText}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
